import './styles/hold-toolbar.scss'

import React from 'react'
import { Modal, Button, Form } from 'semantic-ui-react'

import AsyncFilterDropdown from "../components/AsyncFilterDropdown"
import DateTimeRangeFilter from '../components/DateTimeRangeFilter'

import api from "../redux/api"

const initialState = {
  modalOpen:   false,
  name:        '',
  description: '',
  sender:      '',
  receiver:    '',
  dataType:    '',
  before:      0,
  after:       0,  
}

export default class HoldToolbar extends React.Component {
  state = initialState

  handleNewHold = () => {
    this.setState({ modalOpen: true })
  }

  handleClose = () => {
    this.setState({ modalOpen: false })
  }

  handleConfirm = () => {
    console.log('before', new Date(this.state.before).toISOString())
    console.log('after',  new Date(this.state.after).toISOString())

    this.setState({ ...initialState })
  }

  handleNameDescriptionChange = (e, { name, value }) => {    
    this.setState({ [name]: value })
  }

  handleSenderChange = (data) => {
    this.setState({ sender: data ? data.value : '' })
  }

  handleReceiverChange = (data) => {
    this.setState({ receiver: data ? data.value : '' })
  }

  handleDataTypeChange = (data) => {
    this.setState({ dataType: data ? data.value : '' })
  }

  handleTimeChange = (params) => {
    this.setState({ before: params.before, after: params.after })
  }

  render() {
    const { modalOpen, name, description, sender, receiver, dataType, before, after } = this.state

    const submitEnabled = name && sender && receiver && dataType

    return (
      <div className="hold-toolbar">
        <Button primary onClick={this.handleNewHold}>New Hold</Button>

        <div className="hold-modal">
          <Modal centered={false} open={modalOpen}>
            <Modal.Content>
              <h3>Create New Hold</h3>

              <div className="hold-modal-content">
                <Form>
                  <div className="hold-section">
                    <Form.Field>
                      <label>Name</label>
                      <Form.Input
                        placeholder='Name'
                        name='name'
                        value={name}
                        onChange={this.handleNameDescriptionChange}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>Description</label>
                      <Form.Input
                        placeholder='Description'
                        name='description'
                        value={description}
                        onChange={this.handleNameDescriptionChange}
                      />
                    </Form.Field>
                  </div>

                  <div className="hold-section">
                    <Form.Field>
                      <label>Sender</label>
                      <AsyncFilterDropdown
                        test={true}
                        getOptionsByFilter={api.loadDataSystems}
                        placeholder="Filter by Sender"
                        onChange={this.handleSenderChange}
                        value={sender}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>Receiver</label>
                      <AsyncFilterDropdown
                        test={true}
                        getOptionsByFilter={api.loadDataSystems}
                        placeholder="Filter by Receiver"
                        onChange={this.handleReceiverChange}
                        value={receiver}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>Data Type</label>
                      <AsyncFilterDropdown
                        test={true}
                        getOptionsByFilter={api.loadDataTypes}
                        placeholder="Filter by Data Types"
                        onChange={this.handleDataTypeChange}
                        value={dataType}
                      />
                    </Form.Field>
                  </div>

                  <div className="hold-time">
                    <Form.Field>
                      <label>Time</label>
                      <DateTimeRangeFilter
                        onChange={this.handleTimeChange}
                        defaultFilterConfig={{ after, before }}
                      />
                    </Form.Field>
                  </div>
                </Form>
              </div>
            </Modal.Content>
             <Modal.Actions>
              <Button onClick={this.handleClose}>Cancel</Button>
              <Button onClick={this.handleConfirm} primary disabled={!submitEnabled}>OK</Button>
            </Modal.Actions>
          </Modal>
        </div>
      </div>
    )
  }
}
